import { render } from "./SendCodeToEmail.vue?vue&type=template&id=7f0c4184&scoped=true"
import script from "./SendCodeToEmail.vue?vue&type=script&lang=js"
export * from "./SendCodeToEmail.vue?vue&type=script&lang=js"

import "./SendCodeToEmail.vue?vue&type=style&index=0&id=7f0c4184&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0c4184"]])

export default __exports__